// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"569":"ac7a2ecc","636":"63cf541e","688":"2190c4a3","925":"504e8691"}[chunkId] + ".chunk.css";
};